export default __webpack_public_path__ + "static/media/Path 112.51142496.svg";